// extracted by mini-css-extract-plugin
export var dot = "_qf-2";
export var wave = "_qf-0";
export var waveSmall = "_qf-1";